import React, { useState, useEffect } from 'react';
import { useConsent } from '../contexts/ConsentContext';
import './CookieSettings.css';

const CookieSettings = () => {
  const { 
    isSettingsOpen, 
    consent, 
    saveCustomConsent, 
    closeSettings 
  } = useConsent();

  const [localConsent, setLocalConsent] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
    preferences: false
  });

  useEffect(() => {
    if (isSettingsOpen) {
      setLocalConsent(consent);
    }
  }, [isSettingsOpen, consent]);

  const handleToggle = (category) => {
    if (category === 'necessary') return; // Can't toggle necessary cookies
    
    setLocalConsent(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const handleSave = () => {
    saveCustomConsent(localConsent);
  };

  const handleAcceptAll = () => {
    setLocalConsent({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    });
    saveCustomConsent({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    });
  };

  const handleRejectAll = () => {
    setLocalConsent({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    });
    saveCustomConsent({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    });
  };

  if (!isSettingsOpen) return null;

  return (
    <div className="cookie-settings-overlay">
      <div className="cookie-settings-modal">
        <div className="cookie-settings-header">
          <h2>Cookie Settings</h2>
          <button 
            className="cookie-settings-close" 
            onClick={closeSettings}
            aria-label="Close cookie settings"
          >
            ×
          </button>
        </div>

        <div className="cookie-settings-content">
          <p className="cookie-settings-intro">
            We use cookies to enhance your browsing experience, serve personalized content, 
            and analyze our traffic. You can choose which types of cookies to allow.
          </p>

          <div className="cookie-categories">
            <div className="cookie-category">
              <div className="cookie-category-header">
                <h3>Necessary Cookies</h3>
                <div className="cookie-toggle disabled">
                  <input 
                    type="checkbox" 
                    checked={true} 
                    disabled 
                    readOnly
                  />
                  <span className="cookie-toggle-slider"></span>
                </div>
              </div>
              <p className="cookie-category-description">
                These cookies are essential for the website to function properly. 
                They cannot be disabled and are always active.
              </p>
            </div>

            <div className="cookie-category">
              <div className="cookie-category-header">
                <h3>Analytics Cookies</h3>
                <div className="cookie-toggle">
                  <input 
                    type="checkbox" 
                    checked={localConsent.analytics}
                    onChange={() => handleToggle('analytics')}
                  />
                  <span className="cookie-toggle-slider"></span>
                </div>
              </div>
              <p className="cookie-category-description">
                These cookies help us understand how visitors interact with our website 
                by collecting and reporting information anonymously (Google Analytics).
              </p>
            </div>

            <div className="cookie-category">
              <div className="cookie-category-header">
                <h3>Marketing Cookies</h3>
                <div className="cookie-toggle">
                  <input 
                    type="checkbox" 
                    checked={localConsent.marketing}
                    onChange={() => handleToggle('marketing')}
                  />
                  <span className="cookie-toggle-slider"></span>
                </div>
              </div>
              <p className="cookie-category-description">
                These cookies are used to track visitors across websites to display 
                relevant and engaging advertisements.
              </p>
            </div>

            <div className="cookie-category">
              <div className="cookie-category-header">
                <h3>Preference Cookies</h3>
                <div className="cookie-toggle">
                  <input 
                    type="checkbox" 
                    checked={localConsent.preferences}
                    onChange={() => handleToggle('preferences')}
                  />
                  <span className="cookie-toggle-slider"></span>
                </div>
              </div>
              <p className="cookie-category-description">
                These cookies remember your choices and preferences to provide a 
                more personalized experience.
              </p>
            </div>
          </div>
        </div>

        <div className="cookie-settings-footer">
          <div className="cookie-settings-actions">
            <button 
              className="cookie-settings-btn cookie-settings-btn-secondary" 
              onClick={handleRejectAll}
            >
              Reject All
            </button>
            <button 
              className="cookie-settings-btn cookie-settings-btn-secondary" 
              onClick={handleSave}
            >
              Save Preferences
            </button>
            <button 
              className="cookie-settings-btn cookie-settings-btn-primary" 
              onClick={handleAcceptAll}
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieSettings;
